module.exports = __webpack_public_path__ + "img/Wireshark.463861c.svg";